import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';

import 'scrolltofixed';
import 'slick-carousel';

import OneProductForm from '@/modules/module-oneProductForm';
import OneZoom from '@/modules/module-oneZoom';
import OneDrawer from '@/modules/module-oneDrawer';
import OneTabSystem from '@/modules/module-oneTabSystem';
import OneVideo from '@/modules/module-oneVideo';
import OneRecentlyViewed from '@/modules/module-oneRecentlyViewed';
import OneMarketing from '@/modules/module-oneMarketing';

import '../../styles/modules/oneSizeChart.scss';
import { PUB_SUB_EVENTS, subscribe } from '@/lib/pubsub';

export default Backbone.View.extend({
    
    initialize: function(opts){
        
        console.log('init PDP');
        
        var self = this

        // $content is <body>
        self.$content = self.$el;
        self.$detailContainer = self.$content.find('.product-detail-container');
        
        self.$media = self.$content.find('.product-media');
        self.$mainImage = self.$media.find('#ProductMediaImages');
        self.$thumbImage = self.$media.find('#ProductMediaThumbs');
        self.$mediaSlider = self.$mainImage.find('.images-wrapper');
        self.$thumbSlider = self.$thumbImage.find('.images-wrapper');

        self.$productCore = self.$content.find('.product-core');
        self.$socialIcons = self.$productCore.find('.one-social');
        self.isGiftCard = self.$detailContainer.hasClass('gift-card');
        self.productQty = self.$content.find('.product-qty-container');

        self.$recentlyViewed = self.$content.find('.recently-viewed .items');
        
        // Features
        self.enableMiniCore = false;
        self.isScrollingLayout = self.$content.data('layout') == 'scrolling' ? true : false;
        self.isScrollingGrid = self.$content.hasClass('scrolling-grid');
        self.isSliderLayout = self.$content.data('layout') == 'slider' ? true : false;
        self.isQuickshopLayout = self.$content.data('layout') == 'quickshop' ? true : false;

        // Data
        self.linkedCollectionData = this.el.querySelector('.linked-collection-json') ? JSON.parse(this.el.querySelector('.linked-collection-json').textContent) : null;
        
        if (ORW.enableGTM) {
            ORW.marketing = ORW.marketing || new OneMarketing;
        }

        self.productCore();
        self.initPrice();
        self.readMore();
        
        if (!self.isGiftCard) {
            self.productMedia();
        }
        
        if (!self.isQuickshopLayout) {
            // self.social();
            if (ORW.enableGTM) {
                ORW.marketing.viewItem(self.$productCore);
            }
        } 
        
        if (!self.isGiftCard && !self.isQuickshopLayout) {
            self.zoom();
            self.video();
            self.sizeChart();
            self.accordionsAndTabs();
            self.recentlyViewed();
        }

        OneProductForm.init({
            el: self.el.querySelector('form.add-to-cart-form'),
            preSelect: self.isQuickshopLayout,
            updateURL: !self.isQuickshopLayout,
        });
    },

    events: {
    },
    
    productMedia: function(){
        var self = this;
        var events = {
            'click .image-thumbnail' : function(e){
                e.preventDefault();
                self.$thumbImage.find('.image-thumbnail').removeClass('active');
                var $curr = $(e.currentTarget).addClass('active');
                var index = $curr.data('index') - 1;
                if (self.$media.hasClass('initialized')) {
                    self.$mediaSlider.slick('slickGoTo',index);
                }
            }
        }
        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();
        
        self.$mediaSlider.on('init', function(event, slick, direction){
            self.$media.addClass('initialized');
            $(window).resize();
        });
        self.$mediaSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
            self.$thumbImage.find('.image-thumbnail').removeClass('active');
            self.$thumbImage.find('.image-thumbnail[data-index=' + (nextSlide + 1) + ']').addClass('active');
        })
        self.$mediaSlider.slick({
            dots: true,
            infinite: true,
            speed: 600,
            slidesToShow: 1,
            arrows: false,
            rows: 0,
        });
        
        // if (self.$thumbSlider.find('.image-thumbnail').length > 5) {
        //     self.$thumbSlider.slick({
        //         dots: false,
        //         infinite: false,
        //         speed: 600,
        //         slidesToShow: 5,
        //         arrows: true,
        //         rows: 1,
        //         variableWidth: true,
        //     })
        // }

        // Main Slick slider
        const $imageSlider = this.$el.find('.product-media-images .images-wrapper');
        const imageMain = $imageSlider[0]; // JS element object same as $imageSlider[0]
        // Thumb Images
        const imageThumbs = this.el.querySelector('.product-media-thumbnails .images-wrapper');

        // Check if image elements have more than one value. If not, don't initialize
        const imageVariantValues = new Set(
            [...imageThumbs.querySelectorAll('[data-variant-option-value]')]
            .map(el => el.dataset.variantOptionValue)
            .filter(Boolean) // Remove empty values
        );
        if (imageVariantValues.size <= 1) return;

        subscribe(PUB_SUB_EVENTS.variantOptionsChange, (options) => {

            const filterSelector = options.map(option => `[data-variant-option-value="${ORW.utilities.handleize(option)}"]`).join(',');

            // Maybe no option selected yet
            if (!filterSelector) return

            // Update Main Slick slider (need to do unfilter first to bring back the filtered out slides from previous filter)
            $imageSlider.slick('slickUnfilter');
            const preFilterCheck_main = imageMain.querySelectorAll(filterSelector);
            if (preFilterCheck_main.length === 0) return
            $imageSlider.slick('slickFilter', filterSelector);

            // Update Thumb Images
            const preFilterCheck_thumbs = imageThumbs.querySelectorAll(filterSelector);
            if (preFilterCheck_thumbs === 0) return
            imageThumbs.querySelectorAll('.image-thumbnail').forEach(el => {
                el.hidden = true;
            });
            preFilterCheck_thumbs.forEach(el => {
                el.hidden = false
            });
        });
    },

    initPrice: function() {
        const atc_btn = document.getElementById('AddToCart');
        const sticky_atc = document.getElementById('sticky_atc');
        const priceElem = this.el.querySelector('.product-detail-container .price-box');
        subscribe(PUB_SUB_EVENTS.variantChange, (variant) => {
            let atc_btn_price_html = `<p class="add-to-cart-text">Add to Cart - ${Shopify.formatMoney(variant.price, window.theme.moneyFormat)}</p>`;
            let main_price_html = `<span class="h2 product-price" itemprop="price">${Shopify.formatMoney(variant.price, window.theme.moneyFormat)}</span>`;
            if (variant.compare_at_price) {
                main_price_html += `<span class="product-compare-price">${Shopify.formatMoney(variant.compare_at_price, window.theme.moneyFormat)}</span>`
                priceElem.classList.add('has-special')
            } else {
                priceElem.classList.remove('has-special')
            }
            priceElem.innerHTML = main_price_html;
            atc_btn.innerHTML = atc_btn_price_html;
            sticky_atc.innerHTML = atc_btn_price_html;
        });
    },
    
    productCore: function(){
        var self = this;
        self.productQuantity();
        
        if (!self.isQuickshopLayout) {
            if (self.enableMiniCore) {
                self.productCoreMini();
            }
            
            // if (self.isScrollingLayout && !self.isScrollingGrid) {
            //     self.productCoreScrollFixing()
            // }
            self.productCoreScrollFixing()

            self.productCoreSwatchFilter()
        }
    },
    
    productQuantity: function(){
        var self = this;
        var $input = self.productQty.find('.qty-input[type=number]');
        var qty = $input.data('value');

        var events = {
            'click .product-qty-container .qty-btn' : function(e){
                e.preventDefault();
                var $curr = $(e.currentTarget);
                if($curr.hasClass('plus')){
                    $input[0].stepUp()
                } else {
                    $input[0].stepDown();
                }
                $input.attr('value', $input.val())
            }
        }

        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();
    },

    productCoreScrollFixing: function(){
        var self = this;
        var init = function($elm){
            $elm.scrollToFixed({
                zIndex: 2,
                removeOffsets: true,
                dontSetWidth: false,
                marginTop: function(){
                    return $('header.site-header').outerHeight() + 50;
                },
                limit: function() {
                    var limit = $('.scrolling-fix-stopper').offset().top - $(this).height();
                    return limit;
                }
            });
        }

        // Modified scroll to fix for fixing the product media block on desktop
        self.$scrollFixingCore = self.$media.find('.product-media-inner');

        // Not available on Mobile.
        ORW.utilities.mediaCheck(function () {
            init(self.$scrollFixingCore);
        }, function () {
            self.$scrollFixingCore.trigger('detach.ScrollToFixed');
        });
    },
    
    productCoreMini: function(){
        var self = this;
        var init = function($elm){
            console.log('init minicore');
            $elm.scrollToFixed({
                zIndex: 2,
                removeOffsets: true,
                dontSetWidth: true,
                triggerAtBottom: true,
                marginTop: function(){
                    return $(this).height()*(-1);
                },
                fixed: function(){
                    $(this).addClass('fixed-core fadeInUp animated');
                },
                unfixed: function() {
                    $(this).removeClass('fixed-core fadeInUp animated');
                }
            });
        }
        self.$miniCore = self.$productCore.find('.block-core');
        // Under scrolling layout, miniCore will only available on Small screen.
        ORW.utilities.mediaCheck(function () {
            self.$miniCore.trigger('detach.ScrollToFixed');
            if (!self.isScrollingLayout || self.isScrollingGrid) {
                init(self.$miniCore);
            }
        }, function () {
            self.$miniCore.trigger('detach.ScrollToFixed');
            init(self.$miniCore);
        });
    },

    productCoreSwatchFilter: function(){
        const self = this
        const categories = self.el.querySelectorAll(`.shade-categories .shade-category`)
        const swatches = self.el.querySelectorAll(`.swatches.linked .swatch`)
        const previouslySelectedCategory = sessionStorage.getItem("selectedCategory");
        const previouslySelectedLinkedCollection = sessionStorage.getItem("selectedLinkedCollection");

        const setShadeCategory = (category) => {
            const swatchMatch = self.el.querySelector(`.shade-categories .shade-category[data-category="${category}"]`)
            categories.forEach(category => category.classList.remove('active'));

            swatchMatch.classList.add('active');

            swatches.forEach(swatch => {
                const swatchCategory = swatch.dataset.category;
                swatch.style.display = swatchCategory === category || category === 'all' ? 'block' : 'none';
            });

            if (self.linkedCollectionData !== null) {
                sessionStorage.setItem("selectedCategory", category );
                sessionStorage.setItem("selectedLinkedCollection", self.linkedCollectionData.handle );
            }
        }

        if (previouslySelectedCategory && (previouslySelectedLinkedCollection === self.linkedCollectionData.handle)) {
            setShadeCategory(previouslySelectedCategory);
        }
        
        var events = {
            'click .shade-categories .shade-category:not(.active)' : function(e){            
                setShadeCategory(e.currentTarget.dataset.category);
            }
        }

        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();
    },
    
    social: function(){
        var self = this;
        var events = {
            'click .share-title':function(e){
                self.$socialIcons.toggleClass('active');
            },
        };
        
        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();
    },
    
    zoom: function(){
        var self = this;
        OneZoom.init({
            el: self.$media,
            mainImage: self.$mainImage,
            thumbImage: self.$thumbImage
        });
    },
    
    video: function(){
        var self = this;
        var $videos = self.$media.find('.video-wrapper');
        OneVideo.init({
            el: $videos,
            isResponsive: false,
            bgVideo: true,
            autoplay: false
        });
    },
    
    accordionsAndTabs: function(){
        var self = this;
        OneTabSystem.init({
            el: self.$content
        });
    },
    
    sizeChart: function() {
        var self = this;
        var sizeChartHtml = $('#SizeChartModal')[0].outerHTML;
        $('#SizeChartModal').remove();
        var drawerCtl = OneDrawer.init({
            drawerContent: sizeChartHtml,
            drawerModalId: 'SizeChartDrawerModal',
            triggerEvent: 'click',
            triggerElem: '.size-chart-trigger',
            initCallback: function(){
                OneTabSystem.init({
                    el: $('#SizeChartModal')
                });
            },
            openCallback: function(){},
            closeCallback: function(){},
            events: {}
        });
    },

    readMore: function() {
        const self = this
        const $desc_block = self.$productCore.find(`.block-description`)

        if (!$desc_block.data('read-more')) {
            return
        }

        const events = {
            'click .read-more': function(e){
                const $curr = $(e.currentTarget)
                const temp = $curr.text();

                $desc_block.toggleClass('active')
                $curr.text($curr.data('alt-text'))
                $curr.data('alt-text', temp)
            },
        };
        
        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();
    },

    recentlyViewed: function() {

        let self = this;

        OneRecentlyViewed.init({
            el: self.$recentlyViewed
        });
    },
    
    destroy: function() {
        var self = this;
        self.undelegateEvents();
    },
    
    responsive: function () {
        var self = this;
        ORW.utilities.mediaCheck(function () {
            // Desktop actions
        }, function () {
            // Mobile actions
        })
    },
    
    isMobile: function () {
        if ( ORW.responsive == 'small') {
            return true;
        }
        return false;
    }
});
